export default __webpack_public_path__ + "static/media/Debit.fd5146fb.svg";